var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 40,
    viewBox: "0 0 49 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1342 11.4598C13.9727 6.9725 18.9735 4 24.667 4C30.3606 4 35.3614 6.9725 38.2 11.4598L41.5804 9.32142C38.0396 3.72398 31.789 0 24.667 0C17.5452 0 11.2945 3.72398 7.75375 9.32142L11.1342 11.4598ZM24.667 36C18.9735 36 13.9727 33.0276 11.1342 28.5402L7.75375 30.6786C11.2945 36.276 17.5452 40 24.667 40C31.789 40 38.0396 36.276 41.5804 30.6786L38.2 28.5402C35.3614 33.0276 30.3606 36 24.667 36ZM24.6666 12C25.7712 12 26.6666 12.8954 26.6666 14C26.6666 15.1046 25.7712 16 24.6666 16C23.562 16 22.6666 15.1046 22.6666 14C22.6666 12.8954 23.562 12 24.6666 12ZM24.6666 20C27.9804 20 30.6666 17.3138 30.6666 14C30.6666 10.6863 27.9804 8 24.6666 8C21.3528 8 18.6666 10.6863 18.6666 14C18.6666 17.3138 21.3528 20 24.6666 20ZM24.6666 26C22.4574 26 20.6666 27.7908 20.6666 30H16.6666C16.6666 25.5818 20.2483 22 24.6666 22C29.0848 22 32.6666 25.5818 32.6666 30H28.6666C28.6666 27.7908 26.8758 26 24.6666 26ZM6.66663 18C5.56207 18 4.66663 18.8954 4.66663 20C4.66663 21.1046 5.56207 22 6.66663 22C7.77119 22 8.66663 21.1046 8.66663 20C8.66663 18.8954 7.77119 18 6.66663 18ZM0.666626 20C0.666626 16.6862 3.35293 14 6.66663 14C9.98033 14 12.6666 16.6862 12.6666 20C12.6666 23.3138 9.98033 26 6.66663 26C3.35293 26 0.666626 23.3138 0.666626 20ZM40.6666 20C40.6666 18.8954 41.562 18 42.6666 18C43.7712 18 44.6666 18.8954 44.6666 20C44.6666 21.1046 43.7712 22 42.6666 22C41.562 22 40.6666 21.1046 40.6666 20ZM42.6666 14C39.3528 14 36.6666 16.6862 36.6666 20C36.6666 23.3138 39.3528 26 42.6666 26C45.9804 26 48.6666 23.3138 48.6666 20C48.6666 16.6862 45.9804 14 42.6666 14Z",
    fill: "url(#paint0_linear_25532_2047)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25532_2047",
    x1: 0.666626,
    y1: 0,
    x2: 18.4181,
    y2: 42.6035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F62FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD2BC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.75f4094a62a07e57503f3eb608664332.svg";
export { ForwardRef as ReactComponent };